var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.3741,
    height: 29,
    rx: 5,
    fill: "#D61818",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3437 7.677C10.6771 7.677 7.67708 10.677 7.67708 14.3437C7.67708 18.0103 10.6771 21.0103 14.3437 21.0103C18.0104 21.0103 21.0104 18.0103 21.0104 14.3437C21.0104 10.677 18.0104 7.677 14.3437 7.677ZM16.8104 15.877C17.0771 16.1437 17.0771 16.5437 16.8104 16.8103C16.5437 17.077 16.1437 17.077 15.8771 16.8103L14.3437 15.277L12.8104 16.8103C12.5437 17.077 12.1437 17.077 11.8771 16.8103C11.6104 16.5437 11.6104 16.1437 11.8771 15.877L13.4104 14.3437L11.8771 12.8103C11.6104 12.5437 11.6104 12.1437 11.8771 11.877C12.1437 11.6103 12.5437 11.6103 12.8104 11.877L14.3437 13.4103L15.8771 11.877C16.1437 11.6103 16.5437 11.6103 16.8104 11.877C17.0771 12.1437 17.0771 12.5437 16.8104 12.8103L15.2771 14.3437L16.8104 15.877Z",
    fill: "#D61818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.68da2d9dbae23b4ae41c283e7d5531e3.svg";
export { ForwardRef as ReactComponent };